import { SessionForm } from '@components/Clinicians/session-form';

const LocalStoragePersistedFields: (keyof SessionForm)[] = ['letterReq'];

class SessionFormState {
  private readonly persistMap = new Map<string, unknown>();

  private static instance: SessionFormState;

  public static getInstance(): SessionFormState {
    if (!SessionFormState.instance) {
      SessionFormState.instance = new SessionFormState();
    }
    return SessionFormState.instance;
  }

  private isLocalStorageField(storageKey: string): boolean {
    return LocalStoragePersistedFields.some((field) => storageKey.includes(field));
  }

  get<T>(storageKey: string): T | undefined {
    if (this.isLocalStorageField(storageKey)) {
      const raw = localStorage.getItem(storageKey);
      return raw ? ((JSON.parse(raw).json ?? JSON.parse(raw)) as T) : undefined;
    }

    return this.persistMap.get(storageKey) as T | undefined;
  }

  set<T>(storageKey: string, value: T) {
    if (this.isLocalStorageField(storageKey)) {
      localStorage.setItem(storageKey, JSON.stringify(value));
      return;
    }

    this.persistMap.set(storageKey, value);
  }

  clear(formKey: string, apptId: number) {
    const storageKey = `appointment[${apptId}].${formKey}`;

    if (this.isLocalStorageField(storageKey)) {
      localStorage.removeItem(storageKey);
      return;
    }

    this.persistMap.delete(storageKey);
  }

  clearAppointmentSessionData(appointmentId: number) {
    for (const key in window.localStorage) {
      if (key.includes(`[${appointmentId}]`)) {
        localStorage.removeItem(key);
      }
    }

    for (const key of this.persistMap.keys()) {
      if (key.includes(`[${appointmentId}]`)) {
        this.persistMap.delete(key);
      }
    }
  }
}

const ClinicianSessionFormState = SessionFormState.getInstance();

export default ClinicianSessionFormState;
